// extracted by mini-css-extract-plugin
module.exports = {"devices":"icons_devices_1W-4f"};